import { jsx as _jsx } from "react/jsx-runtime";
import Highlighter from 'react-highlight-words';
import { css } from '../stitches.config';
/**
 * Wrapper of `react-highlight-words` with change of default.
 */
export const TextHighlight = ({ highlightClassName = cls().className, ...props }) => {
    return (_jsx(Highlighter, { highlightClassName: highlightClassName, autoEscape: true, ...props }));
};
const cls = css({
    backgroundColor: '$primary-200',
});
//# sourceMappingURL=text-highlight.js.map